import React, { useContext } from "react";
import Menu from "./Menu";
import Navbar from "./Navbar";
import SectionChipBar from "./SectionChipBar";
import EmergencyBanner from "../SharedComponents/Emergency/EmergencyBanner";
import "./css/mainLayout.css"
import { useNavV6 } from "../../nav/useNavV6";
import HubTabBar from "../../nav/HubTabBar";
import { ShellContext } from "../../nav/ShellContext";

function Layout({ children, padding = true, subNavbarProps = {}, subNavbarContent = null }) {
    const paddingClass = padding ? "mx-3 mx-md-3 px-2 container-p-y" : "";
    const navV6 = useNavV6();
    const inShell = useContext(ShellContext);

    // New navigation only: a page drawn inside a shell already (a shell-less page wrapped by ShellOnNav whose
    // own locked state wraps <Layout> again) must not draw a second sidebar + navbar.
    if (navV6 && inShell) return <>{children}</>;

    const shell = (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <EmergencyBanner />
                    <Navbar {...subNavbarProps} content={subNavbarContent} />
                    {/* Section chip bar — renders nothing outside Content / Schedule / Money. With the new
                        navigation on, Schedule and Money are hubs (HubTabBar) and only Content keeps its chips. */}
                    {navV6 ? (<><HubTabBar /><SectionChipBar only={["content"]} /></>) : <SectionChipBar />}
                    <div className="content-wrapper overflow-y-auto overflow-x-hidden">
                        <div className={`scroll_div flex-grow-1 ${paddingClass}`} >
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
    return navV6 ? <ShellContext.Provider value={true}>{shell}</ShellContext.Provider> : shell;
}
export default Layout;